import { SvgIcon } from "@mui/material";
import React from "react";

const DelendReceiptLong = (props) => (
  <SvgIcon>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height={24}
      viewBox="0 -960 960 960"
      width={24}
      {...props}
    >
      <path d="M222-80q-43.75 0-74.375-30.625T117-185v-95q0-12.75 8.625-21.375T147-310h97v-544q0-10 8-10t16 8l36 36 49-49q4.636-5 10.818-5Q370-874 375-869l48 49 49-49q4.636-5 10.818-5Q489-874 494-869l49 49 49-49q4.636-5 10.818-5Q609-874 614-869l49 49 49-49q4.636-5 10.818-5Q729-874 734-869l49 49 36-36q8-8 16-8t8 10.272V-185q0 43.75-30.625 74.375T738-80H222Zm516-60q20 0 32.5-12.5T783-185v-595H304v470h359q12.75 0 21.375 8.625T693-280v94.845Q693-165 705.5-152.5T738-140ZM386-622q-12 0-20.5-9t-8.5-21.5q0-12.5 8.625-21T387-682h180q12.75 0 21.375 8.675 8.625 8.676 8.625 21.5 0 12.825-8.625 21.325T567-622H386Zm0 134q-12 0-20.5-9t-8.5-21.5q0-12.5 8.625-21T387-548h180q12.75 0 21.375 8.675 8.625 8.676 8.625 21.5 0 12.825-8.625 21.325T567-488H386Zm304-134q-12 0-21-9t-9-21q0-12 9-21t21-9q12 0 21 9t9 21q0 12-9 21t-21 9Zm0 129q-12 0-21-9t-9-21q0-12 9-21t21-9q12 0 21 9t9 21q0 12-9 21t-21 9ZM221-140h412v-110H177v65q0 20 12.65 32.5T221-140Zm-44 0v-110 110Z" />
    </svg>
  </SvgIcon>
);
export default DelendReceiptLong;
